module.exports = __webpack_public_path__ + "static/media/logoWhite.e0470d65.png";